const guarantorsHtml = (guarantors, guarantor) => {
    if (guarantor !== "Yes") return "";
    if (!guarantors || guarantors.length === 0) return "";
    const names = guarantors.map((g) => (g && g.name ? g.name : "")).filter((n) => n).join(", ");
    if (!names) return "";
    return `<div><strong>Other Guarantors:</strong> ${names}</div>`;
};

export default guarantorsHtml;
